
import { useEffect, Suspense } from "react";
import StarryBackground from "../components/StarryBackground";
import SpaceScene from "../components/SpaceScene";
import LoginSheet from "../components/LoginSheet";
import { initStaticAuth } from "../utils/staticAuthInit";

const Index = () => {
  useEffect(() => {
    document.title = "7 for all Global Connect";
    
    // Inicijaliziraj statičku autentifikaciju za statički način rada
    // Ovo omogućuje rad aplikacije bez korisničke prijave
    initStaticAuth();
  }, []);

  return (
    <>
      <StarryBackground count={300} />
      <Suspense fallback={
        <div className="w-full h-full flex items-center justify-center">
          <div className="text-primary text-xl animate-pulse">Učitavanje planete...</div>
        </div>
      }>
        <SpaceScene />
      </Suspense>
      <LoginSheet />
    </>
  );
};

export default Index;
